const config = {
    listeners: {
      basket: {
          added: 'basket.added',
          deleted: 'basket.deleted',
          update: 'basket.update'
      }
    },
    tokens: {
        suggestions: 'c4dafa04799597e147a5e44f84e24ae13bf19d24'
    }
};
export default config;